<template>
  <div class="P_user">
    <div class="P_user_content">
      <div class="P_user_header">
        <div class="P_portrait">
          <img :src="user.img?user.img:'https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/avatars.png'" alt="" />
          <UserHeaderUpload class="P_portrait_uploadtop"/>
        </div>
        <div class="information">
          <h3>
            {{user.name?user.name:user.nickname}}
            <span>{{user.duties?user.duties:""}}</span>
            <!-- <div v-if="this.user.authent*1==1" class="reveal">
              <img class="attestation" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/attestation.jpg" alt=""/>
              <div>
                <span></span>
                您已通过cippe展商认证
              </div>
            </div> -->
          </h3>
          <p>
            <span v-if="user.corpname">
              <img :src="hrefurl+'/public/icon/pc_dizhi.png'" alt="" />
              {{user.corpname}}
              </span>
            <span v-if="user.mobile">
              <img :src="hrefurl+'/public/icon/pc_dianhua.png'" alt="" />
              {{user.mobile?user.mobile:user.phone}}
              </span>
            <span v-if="user.email">
              <img :src="hrefurl+'/public/icon/pc_youxiang.png'" alt="" />
              {{user.email?user.email:"Unavailable"}}
              </span>
          </p>
        </div>
        <span class="editor" @click="open"><img :src="hrefurl+'/public/icon/pc_bainji.png'" alt="" /></span>
      </div>
      <div class="P_user_main">
        <div class="P_user_nav">
          <div class="P_user_title">
            <h2>
              User Center
              <div></div>
            </h2>
          </div>
          <ul class="P_user_collection">
            <!-- <li v-if="this.user.authent*1==1" class="exhLogin" @click="reqExhLoginHref" @mouseover="gody">
              <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanshangdenglu.png" alt=""/>
              展商登录系统
            </li> -->
            <li :class="msg.url==item.url?'active':''" v-for="(item,i) in collect" :key="'collect'+i" @click="userjump(item)">
              <img :src="item.img_url" alt="" />
              {{item.title_en}}
            </li>
          </ul>
          <div class="P_user_title">
            <h2>
              Exhibition Related
              <div></div>
            </h2>
          </div>
          <ul class="related_list">
            <!-- <li class="active"> -->
            <li @click="webHerf('https://en.cippe.com.cn/about-introduction')">
              <img :src="hrefurl+'/public/icon/zhanhuigaikuang.png'" alt="" />
              General Introduction
            </li>
            <li @click="webHerf('https://330003.youtucc.com/s/MzMwMDAz')">
              <img :src="hrefurl+'/public/icon/zhanqianyulan.png'" alt="" />
              Exhibition Preview
            </li>
            <li @click="webHerf('https://en.cippe.com.cn/visitor-guide')">
              <img :src="hrefurl+'/public/icon/canguanzhinan.png'" alt="" />
              Visitor Guide
            </li>
            <li @click="webHerf('https://en.cippe.com.cn/accommodation')">
              <img :src="hrefurl+'/public/icon/jiudianyuding.png'" alt="" />
              Hotel Booking
            </li>
            <li @click="webHerf('https://en.cippe.com.cn/trafficmap')">
              <img :src="hrefurl+'/public/icon/jiaotongditu.png'" alt="" />
              Traffic Map
            </li>
            <li @click="webHerf('https://en.cippe.com.cn/exhibition-stand-contractor')">
              <img :src="hrefurl+'/public/icon/dajian.png'" alt="" />
              Official Contractors
            </li>
            <li @click="webHerf('https://en.cippe.com.cn/freight-forwarder/')">
              <img :src="hrefurl+'/public/icon/yunshu.png'" alt="" />
              Transportation Services
            </li>
            <li>
              <!-- <img src="https://picsum.photos/id/362/40/40" alt="" />
              运输服务 -->
            </li>
          </ul>
          <div class="P_user_title">
            <h2>
              General Enquiry
              <div></div>
            </h2>
          </div>
          <ul class="hotline_list">
            <li>
              <img :src="hrefurl+'/public/icon/canzhan.png'" alt="" />
              Exhibitor Hotline：010-56176968
            </li>
            <li>
              <img :src="hrefurl+'/public/icon/cangaun.png'" alt="" />
              Visitor Hotline：010-56176941
            </li>
            <li>
              <img :src="hrefurl+'/public/icon/rexian.png'" alt="" />
              Technique Hotline：010-50917095
            </li>
            <li>
              <img :src="hrefurl+'/public/icon/rexian.png'" alt="" />
              Media Hotline：010-50917091
            </li>
          </ul>
        </div>
        <!-- 右侧切换 -->
        <div class="P_user_nav_right">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '' }">My Favorites</el-breadcrumb-item>
            <el-breadcrumb-item>{{msg.title_en}}</el-breadcrumb-item>
          </el-breadcrumb>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { reqMyJumpCippe } from "../../../api"
import UserHeaderUpload from "./userHeadUpload"
export default {
  components:{
    UserHeaderUpload
  },
  data(){
    return{
      collect:[
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/yixiangdingdan.png",
          url:"/user/intentionOrder",
          title_cn:"意向订单",
          title_en:"My orders",
          title:"意向订单",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanshangshoucang.png",
          url:"/user/merchantsCollection",
          title_cn:"展商收藏",
          title_en:"Exhibitor Favorites",
          title:"展商收藏",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/zhanpinshoucang.png",
          url:"/user/goodsCollection",
          title_cn:"展品收藏",
          title_en:"My Favorite Products",
          title:"展品收藏",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/yiyuezhanshang.png",
          url:"/user/aboutGoods",
          title_cn:"已约展商",
          title_en:"My Appointments",
          title:"已约展商",
        },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/guanzhongyaoqing.png",
          url:"/user/aboutAudience",
          title_cn:"观众邀约",
          title_en:"Visitor Invitation",
          title:"观众邀约",
        },
        // {
        //   img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/caigou.png",
        //   url:"/user/purchaseManagement",
        //   title_cn:"采购管理",
        //   title_en:"采购管理",
        //   title:"采购管理",
        // },
        // {
        //   img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/gongying.png",
        //   url:"/user/supplyManagement",
        //   title_cn:"供应管理",
        //   title_en:"供应管理",
        //   title:"供应管理",
        // },
        // {
        //   img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/pinglun1.png",
        //   url:"/user/comments",
        //   title_cn:"我的评论",
        //   title_en:"My Comments",
        //   title:"我的评论",
        // },
        {
          img_url:"https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/xunpan.png",
          url:"/user/consulting",
          title_cn:"询盘",
          title_en:"Enquiry",
          title:"询盘",
        }
      ],
      collectActive:'',
      title:'',
      exhLoginUrl:'',//展商登录地址
      godyflag:false,//展商登录系统文字提示
    }
  },
  mounted(){
    this.collectActive = this.$route.path
    let a = this.collect.find(item=>item.url==this.collectActive)
    this.$store.dispatch('userTitle',a)
    if (!this.isLogin) {
      this.$router.push('/home')
    }
    if (this.user.authent*1!=1) {
      this.collect.splice(4,1)
      console.log(1,this.collect);
    }
  },
  methods:{
    open(){//打开修改弹窗
      this.$store.dispatch('information',true)
    },
    userjump(item){
      this.$router.push(item.url)
      // this.collectActive = url
      // this.title = title
      this.$store.dispatch('userTitle',item)
    },
    async reqExhLoginHref(){
      const response = await reqMyJumpCippe()
      console.log(response);
      if (response.code*1==2) {
        this.webHerf('https://'+response.webaddress)
      } else {
        console.log('cuo');
      }
    },
    gody(){
      console.log(123);
      this.godyflag = true
    }

  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
      isLogin:state=>state.user.isLogin,
      msg:state=>state.user.msg,
      information:state=>state.user.information
    })
  },
}
</script>

<style scoped>
  .P_user{
    /* background-color: rgb(243, 217, 226); */
    padding-top: 130px;
    background: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/user/userpage_bg.jpg") no-repeat;
    background-color: white;
    background-size: 100% ;
  }
  .P_user_content{
    max-width: 1200px;
    margin: 0 auto;
  }
  .P_user_header{
    position: relative;
    height: 190px;
    background-color: #008baf;
    background-image: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/user/user_bg.jpg");
    background-size: 100% 100%;
  }
  .P_user_header::after{
    display: block;
    content: "";
    clear: both;
  }
  .P_portrait{
    position: relative;
    float: left;
    width: 114px;
    height: 114PX;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid #a8aaa7;
    margin:40px 88px 20px 88px;
  }
  .P_portrait_uploadtop{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    /* background-color: pink; */
  }
  .P_portrait_uploadtop>>>.el-upload{
    width: 100%;
    height: 100%;
  }
  .information{
    float: left;
    padding: 55px 0 0; 
    color: white;
  }
  .information>h3{
    font-size: 28px;
    /* font-weight: 600; */
  }
  .information>h3>span{
    font-size: 22px;
    /* font-weight: 300; */
    margin-left: 10px;
    vertical-align: bottom;
  }
  .reveal{
    position: relative;
    display: inline-block;
  }
  .attestation{
    height: 20px;
    width: 80px;
    vertical-align: bottom;
    margin-left: 16px;
  }
  .reveal>div{
    display: none;
    position: absolute;
    left: calc(50% - 61px);
    bottom: -70px;
    padding: 10px;
    background-color: white;
    box-shadow: 0 0 2px #000;
    font-size: 12px;
    width: 140px;
    border-radius: 4px;
    color: #333;
  }
  .reveal>div>span{/*三角 */
    position: absolute;
    top: -20px;
    left: calc(50% - 10px);
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid white;
    border-left: 10px solid transparent;
  }
  .reveal:hover div{
    display: inline-block;
  }
  
  .information>p{
    font-size: 16px;
    margin-top: 20px;
  }
  .information>p>span{
    margin-right: 20px;
  }
  .information>p>span>img{
    width: 40px;
    margin-right: 8px;
    vertical-align: middle;
  }
  /* 编辑 */
  .editor{
    position: absolute;
    right: 50px;
    top: 50px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
  }

  /* P_user_main start */
  .P_user_main{
    margin-top: 10px;
    display: flex;
    padding-bottom: 20px;
  }
  .P_user_nav{
    width: 300px;
    /* height: 500px; */
    /* background-color: #f1f1ef; */
    
  }
  .P_user_title{
    background-color: #008baf;
    overflow: hidden;
  }
  .P_user_title>h2{
    position: relative;
    font-size: 28px;
    color: white;
    border-left: 4px solid #fff;
    margin-left: 20px;
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 14px;
    line-height: 1;
    font-family: 'FjallaOne-Regular';
  }
  .P_user_title>h2>div{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    /* background-color: white; */
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid white;
    border-bottom: 10px solid transparent;
    border-left: 10px solid transparent;
  }
  .P_user_collection{
    width: 100%;
    line-height: 70px;
    font-size: 16px;
    color: #585856;
    vertical-align: middle;
    user-select: none;
    background-color: #f1f1ef;
  }
  .P_user_collection>li{
    padding-left: 76px;
    cursor: pointer;
    font-family: 'FjallaOne-Regular';
    white-space: nowrap;
  }

  
  /* 展会相关 start*/
  .related_list{
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    background-color: white;
  }
  .related_list>li{
    width: calc(50% - 2px);
    height: 145px;
    text-align: center;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #f1f1ef;
    box-sizing: border-box;
    padding: 30px 35px 0 35px;
    margin-top: 4px;
    user-select: none;
    font-size: 14px;
    cursor: pointer;
    font-family: 'FjallaOne-Regular';
  }
  .related_list>li:nth-child(1),
  .related_list>li:nth-child(2){
    margin-top: 0;
    /* border-top-right-radius: 0;
    border-top-left-radius: 0; */
  }
  .related_list>li:nth-child(2n+1){
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .related_list>li:nth-child(2n){
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .related_list>li>img{
    max-width: 100%;
    max-height: 60px;
    /* margin-bottom: 10px; */
  }
  /* 展会相关 start*/

  /* 咨询热线 start */
  .hotline_list{
    width: 100%;
    padding: 30px 0;
    font-size: 14px;
    background-color: #f1f1ef;
  }
  .hotline_list>li{
    width: 100%;
    /* line-height: 26px; */
    vertical-align: middle;
    padding: 12px 0;
    text-align: left;
    font-family: 'FjallaOne-Regular';
  }
  .hotline_list>li>img{
    width: 40px;
    vertical-align: middle;
  }
  /* 咨询热线 end */



  .P_user_nav_right{
    width: calc(100% - 310px);
    margin-left: 10px;
    background-color: white;
  }
  .P_user_nav_right>>>.el-breadcrumb{
    font-size: 16px;
    padding: 20px 30px;
    margin-bottom: 10px;
    background-color: white;
    color: #008baf;
    font-family: 'FjallaOne-Regular';
  }
  .P_user_nav_right>>> .el-breadcrumb__inner{
    color: #008baf;
    cursor: pointer;
  }

  /* P_user_main end */

  .P_user_collection>.active,
  .P_user_collection>li:hover,
  .related_list>.active,
  .related_list>li:hover{
    color: #008baf;
    background-color: rgba(0,139,175, .2);
  }
  .P_user_collection>li>img{
    width: 40px;
    vertical-align: middle;
  }


  /* 修改个人资料 start */
  .P_portrait>>>.el-input__inner{
    color: #333;
  }
  .P_user_content>>>.el-dialog--center .el-dialog__body{
    padding-left: 100px;
    padding-right: 120px;
    text-align: center;
  }
  .P_user_content>>>.el-button+.el-button{
    margin-left: 20px;
  }
  .button{
    width: 40%;
    height: 40px;
  }
  .phoneCode{
    width: 56%;
    margin-right: 4%;
  }

  /* 修改个人资料 end */

  @media (min-width: 768px) and (max-width: 1200px) {
    
    .P_user_nav{
      width: 200px;
    }
    .P_user_title>h2{
      margin-left: 20px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .P_user_collection>li{
      padding-left: 20px;
    }
    .related_list>li{
      padding:10px 0;
      height: auto;
    }
    .P_user_nav_right{
      width:calc(100% - 200px)
    }
  }
  @media (min-width: 768px) and (max-width: 992px) {
    .P_portrait{
      margin-left: 10px;
      margin-right: 10px;
    }
  }

</style>